import { Component } from 'react';
import { compose } from 'redux';
import emptyFunction from 'react-utils/emptyFunction';
import { fromJS } from 'immutable';
import styled from 'styled-components';
// @ts-expect-error untyped module
import DSFilterEditor from 'customer-data-filters/components/DSFilterEditor';
// @ts-expect-error untyped module
import DSConnector from 'customer-data-filters/components/fetcher/DSConnector';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { wireCurrencyCode } from 'automation-ui-action-features/queries/currencyQueries';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDSFilterEditor = styled(DSFilterEditor).withConfig({
  displayName: "ClassicEnrollmentFilter__StyledDSFilterEditor",
  componentId: "rxsdz3-0"
})(["min-height:500px;width:100%;flex:1 0 auto;"]);
class ClassicEnrollmentFilter extends Component {
  constructor(...args) {
    super(...args);
    this.handleChange = value => {
      this.props.onChange(fromJS(value));
    };
    this.handleOnEditingChange = event => {
      const {
        onEditingCriteria,
        value
      } = this.props;
      if (!isFilterEmpty(value)) {
        onEditingCriteria(syntheticEvent(!!event.target.value));
      }
    };
    this.handleOnChangeFilterFamily = event => {
      const {
        onEditingCriteria,
        value
      } = this.props;
      if (isFilterEmpty(value)) {
        onEditingCriteria(syntheticEvent(event.target.value !== undefined));
      }
    };
    this.renderIndex = 0;
  }
  componentDidUpdate(prevProps) {
    const currentIsFilterEmpty = isFilterEmpty(prevProps.value);
    const nextIsFilterEmpty = isFilterEmpty(this.props.value);

    // This is to defeat an implementation detail of XOFilters where it will
    // only keep the "initial screen" functionality if isInitialScreenCreate
    // is set to true on the first render.
    if (!currentIsFilterEmpty && nextIsFilterEmpty) {
      this.renderIndex += 1;
    }
  }
  render() {
    const {
      value,
      currencyCode,
      readOnly,
      isUngated,
      hasScope,
      matchStatus,
      'data-test-id': dataTestId
    } = this.props;
    return /*#__PURE__*/_jsx(DSConnector, {
      children: /*#__PURE__*/_jsx(StyledDSFilterEditor, {
        value: value.toJS(),
        currencyCode: currencyCode,
        onChange: this.handleChange,
        onChangeFilterFamily: this.handleOnChangeFilterFamily,
        onDraftChange: emptyFunction,
        onEditingChange: this.handleOnEditingChange,
        isReadOnly: readOnly,
        getIsUngated: isUngated,
        hasScope: hasScope,
        matchStatus: matchStatus,
        "data-test-id": dataTestId,
        isInitialScreenCreate: isFilterEmpty(value)
      }, `filter-editor-${this.renderIndex}`)
    });
  }
}
ClassicEnrollmentFilter.defaultProps = {
  readOnly: false
};
export default compose(wireCurrencyCode, wireAuthConsumer)(ClassicEnrollmentFilter);